import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from './directive' // directive
import ElementUI from 'element-ui'
Vue.use(ElementUI)
Vue.use(directive)
// 字典
import dict from './utils/dict'
import DictTag from '@/components/DictTag'
Vue.use(dict)
Vue.component('DictTag', DictTag)
import 'element-ui/lib/theme-chalk/index.css'
import request from './utils/request'

import ws from '@/utils/websocket'
Vue.prototype.$ws = ws

import './permission'
Vue.prototype.$bus = new Vue()  

Vue.config.productionTip = false
Vue.prototype.$request = request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
